import { ShieldCheck } from 'lucide-react';
import { HeaderButton, IconContainer, HeaderInfo, HeaderTitle, HeaderLabel } from './styled';

const AdminPanelHeader = () => {
    return (
        <HeaderButton>
            <IconContainer>
                <ShieldCheck />
            </IconContainer>
            <HeaderInfo>
                <HeaderTitle>Admin Control Panel</HeaderTitle>
                <HeaderLabel>platform</HeaderLabel>
            </HeaderInfo>
        </HeaderButton>
    );
};

export default AdminPanelHeader;
